import { AnyError, ErrorAlert } from '@if/mui'

interface Props {
  error: AnyError
}

const PageError = ({ error }: Props) => {
  return (
    <div>
      <ErrorAlert error={error} />
    </div>
  )
}

export default PageError
